<template lang="html">
<header class="dsbn-header">
  <div class="brand">
    <svg-icon clazz="sm-hidden dsbn-logo" path="dsbn-horizontal.svg"></svg-icon>
    <img class="adventure-logo" :src="adventure_campus_logo" alt="">
  </div>
  <nav>
    <div class="sm-hidden" link><a href=".">Home</a></div>
    <div class="sm-hidden" link><a href="#about">About</a></div>
    <div class="sm-hidden" link><a href="#contact">Contact</a></div>
    <div button link><a href="https://bookadventure.dsbn.org">Book</a></div>
  </nav>
</header>
</template>

<script>
export default {
  name: 'DSBNHeader',
  data() {
    return {
      adventure_campus_logo: require('~/assets/new-adventure-campus-logo-lt.png')
    }
  }
}
</script>

<style lang="less">
@import '../css/variables';

.dsbn-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: @adventure-primary; //rgba(85, 153, 85, 0.9);
    position: absolute;
    top: 0; left: 0; right: 0;
    z-index: 1;
    padding-left: 4vw;

    .sm-hidden {
      display: none;
      @media(min-width: @mobile) {
        display: inline;
      }
    }

    .adventure-logo,
    svg.dsbn-logo {
        height: 50px;
        padding: 0.3rem;
        .a {
            fill: white;
            box-shadow: 0 0 10px;
        }
    }
    .adventure-logo {
        height: 55px;
        padding-bottom: ~'calc(0.3rem - 5px)';
    }

    nav {
        flex-grow: 1;
        margin: 1em 2em;
        max-width: 400px;

        display: flex;
        justify-content: space-between;

        [link] {
            color: rgba(255,255,255,0.8);
            a,
            a:active,
            a:focus,
            a:hover,
            a:visited {
                color: white;
                text-decoration: none;
            }
            &[button] {
                @media(max-width: @mobile) { margin-left: auto; }
                border: 1px solid rgba(255,255,255,0.5);
                border-radius: 5px;
                padding: 0 0.35em;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// DSBNHeader.vue?6ef460d0